<template>
  <div>
    <el-tabs v-model="tabActive" type="border-card">
      <el-tab-pane label="Current Contract" name="current">
        <ContractState :type="type" :customerUID="customerUID" />
      </el-tab-pane>
      <el-tab-pane label="Contract History" name="history">
        <ContractHistory :type="type" :customerUID="customerUID" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ContractState from "@/views/bank-account/components/contract-state";
import ContractHistory from "@/views/bank-account/components/contract-history";

export default {
  name: "ContractReport",
  components: {
    ContractState,
    ContractHistory
  },
  props: {
    customerUID: String,
    type: String
  },
  data() {
    return {
      tabActive: "current"
    };
  }
};
</script>

<style lang="scss" scoped></style>
